<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.TopFlavor"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-top-flavor">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
